export const faqData = {
  title: 'Frequently asked',
  suggestions: [
    { text: 'How do I add Checkout to my website?', link: 'https://' },
    { text: 'How do I add PayPal Checkout to my app?', link: 'https://' },
    { text: 'How can I accept Apple Pay on web?', link: 'https://' },
    { text: 'How do I accept donations with PayPal?', link: 'https://' },
    {
      text: 'How can I integrate PayPal login to authenticate users in my app?',
      link: 'https://',
    },
  ],
}
export const mostPopular = {
  title: 'Most popular',
  suggestions: [
    { text: 'PayPal Checkout Standard', link: 'https://' },
    { text: 'PayPal Checkout Advanced', link: 'https://' },
    { text: 'Subscriptions', link: 'https://' },
    { text: 'PayPal Donate SDK', link: 'https://' },
  ],
}
